import { AnonymizationAttribute } from './anonymization_attribute';

export type ModalityAggregationRule = { [id: string]: AnonymizationAttribute };

/**
 * Extends the rule with the rule override
 * @param rule
 */
export const extendAnonymizationRule = (
    self: AnonymizationRule,
    rule?: AnonymizationRule
): AnonymizationRule => {
    if (!rule) {
        return self;
    }

    if (rule.fixed_attributes) {
        self.fixed_attributes = {
            ...self.fixed_attributes,
            ...rule.fixed_attributes,
        };
    }

    self.keep_attributes = [
        ...(self.keep_attributes || []),
        ...(rule.keep_attributes || []),
    ];

    self.anon_attributes = [
        ...(self.anon_attributes || []),
        ...(rule.anon_attributes || []),
    ];

    return self;
};

export type AnonymizationRule = {
    /**
     * List of attributes to set to a fixed value
     */
    fixed_attributes?: { [id: string]: string } | null;

    /**
     * List of attributes to copy from the original dataset
     */
    keep_attributes?: string[] | null;

    /**
     * List of attributes to anonymize
     */
    anon_attributes?: AnonymizationAttribute[] | null;
};
